module.exports = __webpack_public_path__ + "img/EducationalCourseLevels.95be859b.svg";